import { actions as authActions } from '@ui/store/auth';
import { initialState, MainState } from './selectors';
import * as actions from './actions';

export default (
  state: MainState = initialState,
  action: actions.MainAction,
) => {
  switch (action.type) {
    case actions.MAIN_ACTIONS.REQUESTED: {
      return {
        ...state,
        loading: true,
      };
    }

    case actions.MAIN_ACTIONS.SUCCEEDED: {
      return {
        ...state,
        ready: true,
        loading: false,
      };
    }

    case actions.MAIN_ACTIONS.FAILED: {
      const { error } = action as actions.MainFailed;
      return { ...state, error, loading: false, ready: true };
    }

    case authActions.AUTH_ACTIONS.LOGOUT_REQUESTED: {
      return { ...state, loading: true };
    }

    case authActions.AUTH_ACTIONS.LOGOUT_FAILED:
    case authActions.AUTH_ACTIONS.LOGOUT_SUCCEEDED: {
      return { ...state, loading: false };
    }

    default: {
      return state;
    }
  }
};



// WEBPACK FOOTER //
// ./src/Main/services/reducer.ts